import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Add, Height, Image, Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { Link } from 'react-router-dom';
import { Assignment } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

//servicios
import { wsGetAll, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 100, align: 'center' },
  { Header: 'Fecha creación', accessor: 'created_at'},
  { Header: 'Nombre vendedor', accessor: 'Nombre'},
  { Header: 'Muestra Catalogo', accessor: 'MuestraCatalogo', width: 100},
  { Header: 'Ruta', accessor: 'Ruta'},
  { Header: 'Conoce cli. al vendedor', accessor: 'ConoceClienteVendedor', width: 100},
  { Header: 'Ofrece marcas P.', accessor: 'OfreceMarcasPotenciales', width: 100},
  { Header: 'Zona', accessor: 'Zona', width: 100},
  { Header: 'Codigo Cliente', accessor: 'CodigoCliente'},
  { Header: 'Nombre Cliente', accessor: 'CardName'},
  { Header: 'Nombre supervisor', accessor: 'NombreVendedor'},
  { Header: 'Informa Promociones', accessor: 'InformaPromocionesPrecios', width: 120},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];


export default WithApp(function Colgate(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [supervisores, setSupervisores] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [valueSearch, setValueSearch] = useState({});

  async function loadSupervisor(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/form-supervisores',filter);
    setDataLoading(false);
    if (response.success) setSupervisores(response.data);
  }
  
  const openModalWithDetails = (idFotoEvidencia, nombreVendedor) => {
    setOpen({ idFotoEvidencia, nombreVendedor });
  };

  return (
    <GridContainer>
      {model.open ? (
          <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadSupervisor()}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Formularios para Supervisores {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadSupervisor}
              getValueSearch={(value) => {setValueSearch(value);}}
              dateRange
              diffRange={0}
              supervisor
            />
            <ReactTable
              excelName="listado_respuestas_supervisores"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={supervisores.map((item, i) => {
                return {
                  num: (
                    <>
                      <div className="actions-right">
                        {i + 1}
                        <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_SHOW}>
                          <Button justIcon round simple color={props.themeContext.buttonColorWarning} 
                          style={{padding:'0',width:'31px',height:'31px',minWidth:'31px'}}>
                            <Link to={`${item.id}`} style={{margin:'0'}}>
                              <Visibility />
                            </Link>
                          </Button>
                        </AllowedGuard>
                        <Button
                          onClick={() => openModalWithDetails(item.idFotoEvidencia, item.NombreVendedor)}
                          style={{padding:'0',width:'31px',height:'31px',minWidth:'31px'}}
                          pointer="true"
                          justIcon round simple
                          color={props.themeContext.buttonColorSuccess}
                        >
                          <Image/>
                        </Button>
                      </div>

                    </>
                  ),
                  created_at: item.created_at,
                  Nombre: item.Nombre,
                  MuestraCatalogo: item.MuestraCatalogo,
                  Ruta: item.Ruta,
                  ConoceClienteVendedor: item.ConoceClienteVendedor,
                  OfreceMarcasPotenciales: item.OfreceMarcasPotenciales,
                  Zona: item.Zona,
                  CodigoCliente: item.CodigoCliente,
                  CardName: item.CardName,
                  NombreVendedor: item.NombreVendedor,
                  InformaPromocionesPrecios: item.InformaPromocionesPrecios,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
